export default "__VITE_ASSET__JPU6GBCb__"